import { render, staticRenderFns } from "./editFormGroup.vue?vue&type=template&id=76f3c054&"
import script from "./editFormGroup.vue.ts?vue&type=script&lang=js&"
export * from "./editFormGroup.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports